<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/yangzhong/yz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器江苏工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省镇江市扬中市，筹建于2018年，占地面积22万平方米<br />
                    专业从事生产混动DHT变速器、新能源驱动电机等汽车核心零部件产品，主要生产DHT-1、9DCT、135kW电桥总成；<br />
                    投产至今荣获“中国汽车工业科学技术进步奖”一等奖、“创新开发项目大奖”、 “中国汽车供应链优秀创新成果”奖、2019年度“电车人” 新能源汽车技术创新奖、2021中国领先电驱动产业链TOP 50奖等多项荣誉称号，多项工艺处于行业领先。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                9（H）DCT装配线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用全自动化台架（可动率95%以上）<br />
                                ② 集成西门子电机与HBM T12高精传感器，实现全扭矩模拟<br />
                                ③ 搭载Discom ROTAS系统进行实时NVH检测<br />
                                ④ 集成差速器半轴和油液循环控制系统，提升设备可动率<br />
                                ⑤ 测试程序具备互锁防错功能<br />
                                ⑥ 全性能测试+real-time分析+数据记录，实现质量全生命周期追溯
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                合箱啮合
                            </div>
                            <div class="destils">
                                ① 实现离合器装配 & P2电机装配<br />
                                ② 工位作业内容：离合器装配 & P2电机装配<br />
                                ③ 技术应用：机器人、力控技术、花键啮合<br />
                                ④ 技术亮点：机器人自动抓取（离合器&P2电机），通过力控控制，实现多段花键自动啮合
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                罩盖螺栓拧紧及总成转线
                            </div>
                            <div class="destils">
                                ① 采用多轴拧紧螺栓及转线工艺<br />
                                ② 工位作业内容：罩盖螺栓拧紧，及总成转线<br />
                                ③ 技术应用：机器人自动拧紧、搬运转线<br />
                                ④ 技术亮点：采用机器人全自动多轴拧紧技术，提高拧紧质量，自动变位，提高效率及柔性，同时集成转线作业，降低成本
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                涂胶检测
                            </div>
                            <div class="destils">
                                ① 采用涂胶及胶线检测工艺<br />
                                ② 工位作业内容：壳体涂胶<br />
                                ③ 技术应用：伺服涂胶、视觉检测+暗室<br />
                                ④ 技术亮点：配置X-Y伺服滑台，实现高柔性涂胶，并对胶线进行100%视觉检测，保证胶线质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                油封定位座柔性压装及转线
                            </div>
                            <div class="destils">
                                ① 采用油封定位座柔性压装及转线<br />
                                ② 工位作业内容：壳体涂胶<br />
                                ③ 技术应用：伺服涂胶、视觉检测+暗室<br />
                                ④ 技术亮点：配置X-Y伺服滑台，实现高柔性涂胶，并对胶线进行100%视觉检测，保证胶线质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-5.jpg" alt="">
                        </div>
                    </div>
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                油管柔性压装
                            </div>
                            <div class="destils">
                                ① 采用油管柔性压装工艺<br />
                                ② 工位作业内容：油管柔性压装<br />
                                ③ 技术应用：机器人、涂油、压装、视觉防错<br />
                                ④ 技术亮点：视觉引导机器人自动完成油管取料，自动涂油，并将其压装到位，对压装状态进行视觉检测，保证装配质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-6.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                合箱压装
                            </div>
                            <div class="destils">
                                ① 采用壳体压装、涂胶及合箱工艺<br />
                                ② 工位作业内容：壳体涂胶及变壳合箱<br />
                                ③ 技术应用：机器人、涂胶、多轴合箱<br />
                                ④ 技术亮点：机器人全自动抓取壳体，进行压装、涂胶后，采用浮动技术实现壳体合箱
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-7.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                拨叉活塞压装
                            </div>
                            <div class="destils">
                                ① 采用拨叉活塞自动装配<br />
                                ② 工位作业内容：拨叉活塞自动压装<br />
                                ③ 技术应用：机器人、涂油、压装、视觉防错<br />
                                ④ 技术亮点：双机器人自动完成活塞涂油，并将其压装到位，并对压装状态进行视觉检测，保证装配质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-8.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT1线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                电枢热套
                            </div>
                            <div class="destils">
                                ① 采用壳体双电机腔加热工艺<br />
                                ② 通过硬臂吊具上料搭配转台送件；一拖二单机分体式加热机保证了两机壳腔体同时热胀；加热后，机器人抓取工件放入压装工位完成双电枢同步压装；压装后，机器人抓取工件放入冷却工位，内部三面循环运风实现壳体快速冷却。这套系统极大地保障了动作灵活性和工艺连贯性，处于行业先进水平<br />
                                ③ 应用了机器人柔性加热-热套及冷却技术，攻克了电机行业热套稳定性和自动化的课题
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                壳体压装
                            </div>
                            <div class="destils">
                                ① 采用机器人夹具抓取工件转线至滑台，滑台带动壳体移至压装工位进行压装，然后机器人再次抓取工件进行转线<br />
                                ② 机器人搭配换枪盘夹具组件、电缸搭配快换压头和滑台搭配快换托盘组件实现多机型快速切换。极大地保障了精度、灵活性和兼容性，处于行业的先进水平
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                轴系测量与拼接
                            </div>
                            <div class="destils">
                                工位通过人工上料、转台送件，抓取机器人连同夹具抓取工件移位至检测工位，结合位移传感器完成测量，装配机器人连同夹具抓取工件放入壳体完成组装。
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                机器人拧紧
                            </div>
                            <div class="destils">
                                本工位机器人搭配电动拧紧轴进行螺栓自动拧紧和扭矩自动测量。实现多机型快速切换
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 对组装好的总成系统进行终测试，避免出现残次品<br />
                                ② 工位采用输入输出机构模拟箱体实际运行状态，通过NVH机构进行噪音检测，最终判断被测件是否装配合格<br />
                                ③ 显示仪1显示台架电机的转速扭矩曲线，显示被测件的离合器压力、档位、电压、电流、转速、扭矩等数据状态，显示仪2显示振动传感器的能量图以及台架电机的转速、扭矩图曲线，显示的是当前NVH测试步骤的数据状态
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>



    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器江苏工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/tr/yangzhong.html'
};

import { createApp } from 'vue';
import App from './yangzhong.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./yangzhong.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
